import React from 'react';

import System from './System';
import Validation from './Validation';

function Notifications (props) {
    return (
        <>
            <System />
            <Validation />
        </>
    );
}

export default Notifications;
